module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kp-modular-label kp-label-step"
  }, [_vm._v("\n  " + _vm._s(_vm.$t('edit.canvas.you_are_editing')) + " "), _c('span', {
    staticClass: "kp-label-id"
  }, [_vm._v(_vm._s(_vm.$t('general.labels.step')) + " " + _vm._s(_vm.step.position + 1))])])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-4a359ae8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/canvas/step/TopMessage.vue
 ** module id = 818
 ** module chunks = 1
 **/